<template>
    <vs-sidebar
        absolute
        v-model="active"
        :open.sync="activeSidebar"
        >
        <template #logo>
          <b-link @click="close()">
              <span class="h2">
                <b-icon icon="backspace" aria-hidden="true"></b-icon>
              </span>
          </b-link>
        </template>
        <vs-sidebar-item id="usuario" :to="{ name: 'Home'}">
         {{usuario}}
        </vs-sidebar-item>
        <vs-sidebar-item id="home" :to="{ name: 'Home'}">
          <template #icon>
            <i class='bx bx-home'></i>
          </template>
          Home
        </vs-sidebar-item>
        <vs-sidebar-item id="pacientes" :to="{ name: 'Pacientes'}">
          <template #icon>
            <b-icon icon="people" aria-hidden="true"></b-icon>
          </template>
          Pacientes
        </vs-sidebar-item>
        <vs-sidebar-item id="agenda" :to="{ name: 'Agenda'}">
          <template #icon>
            <b-icon icon="calendar3" aria-hidden="true"></b-icon>
          </template>
          Agenda
        </vs-sidebar-item>
        <vs-sidebar-item id="listareforco" :to="{ name: 'Listareforco'}">
          <template #icon>
            <b-icon icon="people" aria-hidden="true"></b-icon>
          </template>
          Emergência
        </vs-sidebar-item>
    </vs-sidebar>
</template>
<script>
export default {
  name: 'sidebar',
  props: {
    activeSidebar: {
      type: Boolean,
      default: false
    },
    usuario: {
      type: String
    }
  },
  data () {
    return {
      active: 'home'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sidebar.vue